import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
type StartupFeeModalProps = {
  open: boolean,
  setOpen: (check: boolean) => void,
  baseUrl: string,
  currentUser: any,
  client: any,
  getAgents: () => void,
}
export default function MinutePriceModal({ open, setOpen, baseUrl, currentUser, client, getAgents }: StartupFeeModalProps) {

  const [fee, setFee] = useState("");


  useEffect(() => {
    function handleEsc(event: any) {
      if (event.key === "Escape") setOpen(false);
    }
    document.addEventListener("keydown", handleEsc);
  }, [])

  const handleSave = async () => {
    try {
      let formData = new FormData();
      formData.append("token", currentUser?.token);
      formData.append("customer_minute_price", fee);
      formData.append("client_uid", client?.uid);

      const response = await axios.post(baseUrl + '/updateAllAgentsMinutePrice', formData);

      if (response.data.status === "OK") {
        Swal.fire({
          title: 'Suksess',
          icon: 'success',
          text: response.data.data,
          timer: 1500,
        })
        setOpen(false);
        getAgents();
      } else {
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: response.data.data,
        })
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {/* Trigger */}
      <button
        onClick={() => setOpen(true)}
        className="text-blue-600 hover:underline flex items-center gap-1"
      >
        Customer Minute price ✏️
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Modal box */}
            <motion.div
              className="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              <h3 className="mb-4 text-lg font-semibold text-gray-800">
                Edit Customer Minute Price
              </h3>

              <input
                type="number"
                placeholder="Enter customer minuter price"
                value={fee}
                onChange={(e) => setFee(e.target.value)}
                className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />

              <div className="mt-6 flex justify-end gap-3">
                <button
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
                >
                  Cancel
                </button>

                <button
                  onClick={handleSave}
                  className="rounded-lg bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
